export function PostStatusData() {
    return {
        name: "post_status",
        label: "Post Status",
        primitiveType: "string"
    };
}

export default PostStatusData;
